import xlsx from 'xlsx';

export type EvaluationSheet = Record<number, { name: string, data: string[][] }>;

export default function downloadAsExcel(data: string[][], fn: string): void {
  const filename = (fn.length > 31) ? fn.substr(fn.length - 31) : fn;
  const sheet = xlsx.utils.aoa_to_sheet(data);
  const book = xlsx.utils.book_new();
  const sheetName = filename.replace(new RegExp('/', 'g'), '_');
  xlsx.utils.book_append_sheet(book, sheet, sheetName);
  xlsx.writeFile(book, `${sheetName}.xlsx`); // will trigger download of the file
}
/**
 * Use this export function for multiple sheets in a workbook
 */
export function downloadExcelSheets(data: EvaluationSheet, fn: string): void {
  let filename = (fn.length > 31) ? fn.substr(fn.length - 31) : fn;
  filename = filename.replace(new RegExp('/', 'g'), '_');
  const book = xlsx.utils.book_new();
  Object.entries(data).forEach(([key, val]) => {
    const sheet = xlsx.utils.aoa_to_sheet(val.data);
    const sheetName = val.name || key;
    xlsx.utils.book_append_sheet(book, sheet, sheetName);
  });
  xlsx.writeFile(book, `${filename}.xlsx`); // will trigger download of the file
}
